/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthToken } from '../models/AuthToken'
import type { Code } from '../models/Code'
import type { Credentials } from '../models/Credentials'
import type { DeviceAuthToken } from '../models/DeviceAuthToken'
import type { DeviceType } from '../models/DeviceType'
import type { EmployeeCredentials } from '../models/EmployeeCredentials'
import type { SignedUrl } from '../models/SignedUrl'
import type { UserAuthToken } from '../models/UserAuthToken'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AuthenticationService {
  /**
   * Authenticate as device or employee with a code
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static loginViaCode(requestBody?: Code): CancelablePromise<{
    data?: {
      auth_token?: AuthToken
      auth_type?: string
      device_token: DeviceAuthToken
      user_token?: UserAuthToken
      type: DeviceType
    }
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/code/login',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * Authenticate with email and password to get an auth token
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static loginUser(requestBody?: Credentials): CancelablePromise<{
    data?: {
      auth_token?: AuthToken
      user_token: UserAuthToken
      device_token: DeviceAuthToken
      type: DeviceType
    }
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/user/login',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 📱 Authenticate as employee on multiuserdevice for self service area
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static loginUserWithPin(
    requestBody?: EmployeeCredentials,
  ): CancelablePromise<{
    data?: {
      auth_token?: AuthToken
      user_token: UserAuthToken
    }
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/user/loginWithPin',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        403: `The request was forbidden, check user permissions`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 👤 Get a signed url for sso
   * @returns any OK
   * @throws ApiError
   */
  public static generateOfficeSessionUrl(): CancelablePromise<{
    data?: SignedUrl
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/auth/user/officeSessionUrl',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 📱 Get a signed url for sso
   * @returns any OK
   * @throws ApiError
   */
  public static generateOfficeSessionUrlForDevice(): CancelablePromise<{
    data?: SignedUrl
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/auth/device/officeSessionUrl',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 👤 Logout. Invalidate token of an authenticated user.
   * @returns any OK
   * @throws ApiError
   */
  public static logoutUser(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/user/logout',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 👤 Reset password.
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static resetPassword(requestBody?: {
    email: string
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/user/resetPassword',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 📱 Logout. Invalidate token of an authenticated device.
   * @returns any OK
   * @throws ApiError
   */
  public static logoutDevice(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/device/logout',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
}
